import Placeholder from '@atlaskit/react-ufo/placeholder';
import UFOSegment from '@atlaskit/react-ufo/segment';
var DefaultUFOSegmentComponent = UFOSegment;
var entryPointConfig = {
  PlaceholderComponent: Placeholder,
  UFOSegmentComponent: DefaultUFOSegmentComponent,
  ModalErrorFallback: function ModalErrorFallback() {
    return null;
  }
};
export function initEntryPointConfig(overrides) {
  Object.assign(entryPointConfig, overrides);
  return entryPointConfig;
}
export function useEntryPointConfig() {
  return entryPointConfig;
}